var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

export default weakMemoize;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@emotion/weak-memoize/dist/weak-memoize.browser.esm.js
// module id = 273
// module chunks = 0 15 16 17 18 20